export default __webpack_public_path__ + "static/media/hiload-segment-tumbnail.adf46275.webp";